var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "fill-height": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("v-btn", { attrs: { small: "", to: "/quotes" } }, [
                _vm._v("Back to Quotes")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !this.$route.params.id && !this.order._id
        ? _c(
            "v-layout",
            { attrs: { row: "", "fill-height": "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm8: "", "offset-sm2": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", [_c("h4", [_vm._v("Customer")])]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c(
                          "div",
                          { staticStyle: { position: "relative" } },
                          [
                            _c("v-text-field", {
                              attrs: { placeholder: "Search Customers" },
                              on: {
                                click: function($event) {
                                  _vm.showCustomerList = !_vm.showCustomerList
                                },
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  _vm.getCustomers(),
                                    (_vm.showCustomerList = true)
                                }
                              },
                              model: {
                                value: _vm.searchCustomer,
                                callback: function($$v) {
                                  _vm.searchCustomer = $$v
                                },
                                expression: "searchCustomer"
                              }
                            }),
                            _vm._v(" "),
                            _vm.showCustomerList
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      background: "#fff",
                                      "z-index": "1",
                                      width: "100%",
                                      "min-height": "150px",
                                      "max-height": "300px",
                                      "overflow-y": "auto"
                                    }
                                  },
                                  _vm._l(_vm.customers, function(customer) {
                                    return _c(
                                      "div",
                                      {
                                        key: customer._id,
                                        staticClass: "pa-2 singleCustomer",
                                        on: {
                                          click: function($event) {
                                            ;(_vm.existingCustomer =
                                              customer._id),
                                              (_vm.searchCustomer =
                                                customer.firstName +
                                                " " +
                                                customer.lastName),
                                              (_vm.showCustomerList = false)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(customer.firstName) +
                                            " " +
                                            _vm._s(customer.lastName) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            !_vm.existingCustomer
                              ? _c("h4", [_vm._v("Create New Customer:")])
                              : _c("h4", [_vm._v("Existing Customer")]),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _vm.$v.customer.firstName.$error
                              ? _c("div", { staticClass: "red--text" }, [
                                  _vm._v("Please enter first name")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: {
                                label: "First Name",
                                v: _vm.$v.customer.firstName
                              },
                              model: {
                                value: _vm.customer.firstName,
                                callback: function($$v) {
                                  _vm.$set(_vm.customer, "firstName", $$v)
                                },
                                expression: "customer.firstName"
                              }
                            }),
                            _vm._v(" "),
                            _vm.$v.customer.lastName.$error
                              ? _c("div", { staticClass: "red--text" }, [
                                  _vm._v("Please enter last name")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "Last Name" },
                              model: {
                                value: _vm.customer.lastName,
                                callback: function($$v) {
                                  _vm.$set(_vm.customer, "lastName", $$v)
                                },
                                expression: "customer.lastName"
                              }
                            }),
                            _vm._v(" "),
                            !_vm.$v.customer.email.required &&
                            _vm.$v.customer.email.$error
                              ? _c("div", { staticClass: "red--text" }, [
                                  _vm._v("Please enter email")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$v.customer.email.email
                              ? _c("div", { staticClass: "red--text" }, [
                                  _vm._v("Please enter valid email")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "Email" },
                              model: {
                                value: _vm.customer.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.customer, "email", $$v)
                                },
                                expression: "customer.email"
                              }
                            }),
                            _vm._v(" "),
                            _vm.$v.customer.phone.$error
                              ? _c("div", { staticClass: "red--text" }, [
                                  _vm._v("Please enter phone")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-text-field", {
                              attrs: { label: "Phone" },
                              model: {
                                value: _vm.customer.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.customer, "phone", $$v)
                                },
                                expression: "customer.phone"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "v-card",
                              [
                                _c("v-card-title", [
                                  _c("h4", [_vm._v("Address:")])
                                ]),
                                _vm._v(" "),
                                _c("v-divider"),
                                _vm._v(" "),
                                _c(
                                  "v-card-text",
                                  [
                                    _vm.$v.address.address.$error
                                      ? _c(
                                          "div",
                                          { staticClass: "red--text" },
                                          [
                                            _vm._v(
                                              "Please enter street address"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: { label: "Street Address" },
                                      model: {
                                        value: _vm.address.address,
                                        callback: function($$v) {
                                          _vm.$set(_vm.address, "address", $$v)
                                        },
                                        expression: "address.address"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.$v.address.city.$error
                                      ? _c(
                                          "div",
                                          { staticClass: "red--text" },
                                          [_vm._v("Please enter city")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: { label: "Suburb / City" },
                                      model: {
                                        value: _vm.address.city,
                                        callback: function($$v) {
                                          _vm.$set(_vm.address, "city", $$v)
                                        },
                                        expression: "address.city"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.$v.address.state.$error
                                      ? _c(
                                          "div",
                                          { staticClass: "red--text" },
                                          [_vm._v("Please select state")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.states,
                                        "item-text": "name",
                                        "item-value": "code",
                                        label: "State"
                                      },
                                      model: {
                                        value: _vm.address.state,
                                        callback: function($$v) {
                                          _vm.$set(_vm.address, "state", $$v)
                                        },
                                        expression: "address.state"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.$v.address.postcode.$error
                                      ? _c(
                                          "div",
                                          { staticClass: "red--text" },
                                          [_vm._v("Please enter postcode")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: { label: "Postcode" },
                                      model: {
                                        value: _vm.address.postcode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.address, "postcode", $$v)
                                        },
                                        expression: "address.postcode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-checkbox", {
                              attrs: { label: "Different Shipping Address?" },
                              model: {
                                value: _vm.differentShippingAddress,
                                callback: function($$v) {
                                  _vm.differentShippingAddress = $$v
                                },
                                expression: "differentShippingAddress"
                              }
                            }),
                            _vm._v(" "),
                            _vm.differentShippingAddress
                              ? _c(
                                  "v-card",
                                  [
                                    _c("v-card-title", [
                                      _c("h4", [_vm._v("Shiping Address:")])
                                    ]),
                                    _vm._v(" "),
                                    _c("v-divider"),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      [
                                        _vm.$v.shippingAddress.address.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [
                                                _vm._v(
                                                  "Please enter street address"
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Street Address" },
                                          model: {
                                            value: _vm.shippingAddress.address,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.shippingAddress,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "shippingAddress.address"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.$v.shippingAddress.city.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [_vm._v("Please enter city")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Suburb / City" },
                                          model: {
                                            value: _vm.shippingAddress.city,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.shippingAddress,
                                                "city",
                                                $$v
                                              )
                                            },
                                            expression: "shippingAddress.city"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.$v.shippingAddress.state.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [_vm._v("Please select state")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.states,
                                            "item-text": "name",
                                            "item-value": "code",
                                            label: "State"
                                          },
                                          model: {
                                            value: _vm.shippingAddress.state,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.shippingAddress,
                                                "state",
                                                $$v
                                              )
                                            },
                                            expression: "shippingAddress.state"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.$v.shippingAddress.postcode.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [_vm._v("Please enter postcode")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Postcode" },
                                          model: {
                                            value: _vm.shippingAddress.postcode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.shippingAddress,
                                                "postcode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "shippingAddress.postcode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", large: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.createBlankQuote()
                                  }
                                }
                              },
                              [_vm._v("Add")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", large: "" },
                                on: {
                                  click: function($event) {
                                    _vm.fetchFromCartModal = true
                                  }
                                }
                              },
                              [_vm._v("Fetch from Cart")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-layout",
            { attrs: { row: "", "fill-height": "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _c(
                    "v-form",
                    { attrs: { enctype: "multipart/form-data" } },
                    [
                      this.$route.params.id || this.order._id
                        ? _c("div", [
                            _c("label", [
                              _vm._v("Order Code: "),
                              _c("b", [_vm._v(_vm._s(_vm.order.orderCode))])
                            ])
                          ])
                        : _c(
                            "div",
                            [
                              _c("label", [
                                _vm._v(
                                  "Order Code (If left blank one will be generated):"
                                )
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  name: "orderCode",
                                  label: "Order Code"
                                },
                                model: {
                                  value: _vm.order.orderCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.order, "orderCode", $$v)
                                  },
                                  expression: "order.orderCode"
                                }
                              })
                            ],
                            1
                          ),
                      _c("br"),
                      _vm._v(" "),
                      _c("label", [_vm._v("Quote Type:")]),
                      _c("br"),
                      _vm._v(" "),
                      _vm.$v.order.quoteType.$error
                        ? _c("div", { staticClass: "red--text" }, [
                            _vm._v("Please select Quote Type")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          model: {
                            value: _vm.order.quoteType,
                            callback: function($$v) {
                              _vm.$set(_vm.order, "quoteType", $$v)
                            },
                            expression: "order.quoteType"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: "Off Plan",
                              color: "primary",
                              value: "Off Plan"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: "Customer Measurements",
                              color: "primary",
                              value: "Customer Measurements"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: "Check Measure",
                              color: "primary",
                              value: "Check Measure"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [_c("h4", [_vm._v("Items")])]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-data-table",
                            {
                              ref: "sortableTable",
                              attrs: {
                                headers: _vm.itemHeaders,
                                items: _vm.indexedItems,
                                "item-key": "id",
                                "rows-per-page-items": _vm.rowsPerPageItems,
                                pagination: _vm.pagination,
                                loading: _vm.itemsLoading,
                                expand: true
                              },
                              on: {
                                "update:pagination": function($event) {
                                  _vm.pagination = $event
                                }
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "tr",
                                        {
                                          staticClass: "sortableRow sortHandle"
                                        },
                                        [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getItemName(props.item)
                                              ) + "\n                "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(props.item.type))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-right" },
                                            [_vm._v(_vm._s(props.item.width))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-xs-right" },
                                            [_vm._v(_vm._s(props.item.drop))]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.getItemTotal(props.item)
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.editItem(
                                                        props.item.id
                                                      ),
                                                        _vm.doubleEditItem(
                                                          props.item
                                                        )
                                                    }
                                                  }
                                                },
                                                [_vm._v("edit")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-icon",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.confirmDeleteItem(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("delete")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-icon",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showHideDetails(
                                                        props.item.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("keyboard_arrow_down")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.showDetails[
                                                          props.item.id
                                                        ] === true,
                                                      expression:
                                                        "showDetails[props.item.id] === true"
                                                    }
                                                  ],
                                                  staticStyle: {
                                                    position: "absolute",
                                                    "z-index": "1",
                                                    width: "100%",
                                                    left: "0"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    {
                                                      staticStyle: {
                                                        background: "#eee"
                                                      },
                                                      attrs: { flat: "" }
                                                    },
                                                    [
                                                      props.item.type !=
                                                        "Misc" &&
                                                      props.item.type !=
                                                        "Motor Accessories" &&
                                                      props.item.type !=
                                                        "Custom Curtain"
                                                        ? _c(
                                                            "v-card-text",
                                                            [
                                                              props.item.fabric
                                                                ? _c("p", [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Fabric:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .fabric
                                                                            .name
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              props.item.color
                                                                ? _c("p", [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Colour:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .color
                                                                            .name
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                props.item
                                                                  .variations,
                                                                function(
                                                                  variation,
                                                                  key
                                                                ) {
                                                                  return _c(
                                                                    "p",
                                                                    {
                                                                      key: key
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            key
                                                                              .charAt(
                                                                                0
                                                                              )
                                                                              .toUpperCase() +
                                                                              key
                                                                                .slice(
                                                                                  1
                                                                                )
                                                                                .split(
                                                                                  /(?=[A-Z])/
                                                                                )
                                                                                .join(
                                                                                  " "
                                                                                )
                                                                          ) +
                                                                            ": "
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      key ===
                                                                        "secondFabric" ||
                                                                      key ===
                                                                        "secondColor"
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  variation
                                                                                    ? variation.name
                                                                                    : ""
                                                                                ) +
                                                                                  " "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  variation
                                                                                ) +
                                                                                  " "
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              props.item
                                                                .motorPrice > 0
                                                                ? _c("p", [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Motor:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .motor
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              props.item
                                                                .motorPrice > 0
                                                                ? _c("p", [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Motor Price:"
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .motorPrice
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              props.item.notes
                                                                ? _c("p", [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        "Line Item Notes: "
                                                                      )
                                                                    ]),
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .notes
                                                                      )
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      props.item.type ==
                                                      "Custom Curtain"
                                                        ? _c(
                                                            "v-card-text",
                                                            _vm._l(
                                                              props.item
                                                                .variations,
                                                              function(
                                                                variation,
                                                                key
                                                              ) {
                                                                return _c(
                                                                  "p",
                                                                  { key: key },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          key
                                                                            .charAt(
                                                                              0
                                                                            )
                                                                            .toUpperCase() +
                                                                            key
                                                                              .slice(
                                                                                1
                                                                              )
                                                                              .split(
                                                                                /(?=[A-Z])/
                                                                              )
                                                                              .join(
                                                                                " "
                                                                              )
                                                                        ) + ": "
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    (key ===
                                                                      "brand" ||
                                                                      key ===
                                                                        "range") &&
                                                                    variation
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                variation.name
                                                                              ) +
                                                                                " "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                variation
                                                                              ) +
                                                                                " "
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      props.item.type ==
                                                      "Motor Accessories"
                                                        ? _c("v-card-text", [
                                                            _c("div", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Quantity"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid",
                                                                    width:
                                                                      "235px"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "qty_btn",
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                        color:
                                                                          "primary"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.quantityMinus(
                                                                            props.item
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "-"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .quantity
                                                                      ) +
                                                                      "\n                            "
                                                                  ),
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "qty_btn",
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                        color:
                                                                          "primary"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.quantityPlus(
                                                                            props.item
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "+"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ])
                                                          ])
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c("v-progress-linear", {
                                attrs: {
                                  slot: "progress",
                                  color: "primary",
                                  indeterminate: ""
                                },
                                slot: "progress"
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-xl": "" } },
                            [
                              _c("label", [_vm._v("Order Type:")]),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "" },
                                  on: {
                                    change: function($event) {
                                      return _vm.checkOrderItemsForShipping()
                                    }
                                  },
                                  model: {
                                    value: _vm.orderType,
                                    callback: function($$v) {
                                      _vm.orderType = $$v
                                    },
                                    expression: "orderType"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Delivery",
                                      color: "primary",
                                      value: "Delivery"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Install",
                                      color: "primary",
                                      value: "Install"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.orderType === "Delivery"
                                ? _c("v-text-field", {
                                    attrs: {
                                      name: "shipping",
                                      label: "Shipping"
                                    },
                                    model: {
                                      value: _vm.order.shipping,
                                      callback: function($$v) {
                                        _vm.$set(_vm.order, "shipping", $$v)
                                      },
                                      expression: "order.shipping"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.incInstall && _vm.orderType === "Install"
                                ? _c("v-text-field", {
                                    attrs: {
                                      name: "install",
                                      label: "Install"
                                    },
                                    model: {
                                      value: _vm.order.install,
                                      callback: function($$v) {
                                        _vm.$set(_vm.order, "install", $$v)
                                      },
                                      expression: "order.install"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { name: "measure", label: "Measure" },
                                model: {
                                  value: _vm.order.measure,
                                  callback: function($$v) {
                                    _vm.$set(_vm.order, "measure", $$v)
                                  },
                                  expression: "order.measure"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [_c("h4", [_vm._v("Pricing")])]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-text-field",
                                {
                                  attrs: { label: "Apply Promocode" },
                                  model: {
                                    value: _vm.promocode,
                                    callback: function($$v) {
                                      _vm.promocode = $$v
                                    },
                                    expression: "promocode"
                                  }
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "append" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removePromocode(1)
                                            }
                                          }
                                        },
                                        [_vm._v("Remove")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.applyPromocode()
                                            }
                                          }
                                        },
                                        [_vm._v("Apply")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.order.promocodeID
                                ? _c(
                                    "v-text-field",
                                    {
                                      attrs: { label: "Apply Promocode2" },
                                      model: {
                                        value: _vm.promocode2,
                                        callback: function($$v) {
                                          _vm.promocode2 = $$v
                                        },
                                        expression: "promocode2"
                                      }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "append" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removePromocode(2)
                                                }
                                              }
                                            },
                                            [_vm._v("Remove")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.applyPromocode()
                                                }
                                              }
                                            },
                                            [_vm._v("Apply")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-tile",
                                [
                                  _c("v-list-tile-content", [
                                    _vm._v("Sub Total:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    { staticClass: "align-end" },
                                    [_vm._v("$" + _vm._s(_vm.order.subTotal))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _c("v-list-tile-content", [
                                    _vm._v("Shipping:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    { staticClass: "align-end" },
                                    [_vm._v("$" + _vm._s(_vm.order.shipping))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.incInstall
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v("Install:")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-end" },
                                        [
                                          _vm._v(
                                            "$" + _vm._s(_vm.order.install)
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _c("v-list-tile-content", [
                                    _vm._v("Measure:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    { staticClass: "align-end" },
                                    [_vm._v("$" + _vm._s(_vm.order.measure))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _c("v-list-tile-content", [
                                    _vm._v("Discount:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    { staticClass: "align-end" },
                                    [_vm._v("-$" + _vm._s(_vm.order.discount))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _c("v-list-tile-content", [
                                    _c("h4", [_vm._v("Total:")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    { staticClass: "align-end" },
                                    [
                                      _c("h4", [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              _vm.order.subTotal +
                                                (_vm.order.shipping == "" ||
                                                _vm.order.shipping == null
                                                  ? 0
                                                  : parseInt(
                                                      _vm.order.shipping
                                                    )) +
                                                (_vm.order.install == "" ||
                                                _vm.order.install == null
                                                  ? 0
                                                  : parseInt(
                                                      _vm.order.install
                                                    )) +
                                                (_vm.order.measure == "" ||
                                                _vm.order.measure == null
                                                  ? 0
                                                  : parseInt(
                                                      _vm.order.measure
                                                    )) -
                                                _vm.order.discount
                                            )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [_c("h4", [_vm._v("Customer")])]),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("v-card-text", [
                            _c(
                              "div",
                              [
                                _vm.customers
                                  ? _c("v-autocomplete", {
                                      attrs: {
                                        items: _vm.customers,
                                        "item-value": "_id",
                                        label: "Select Existing Customers",
                                        filter: _vm.filterCustomer
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function(data) {
                                              return [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      data.item.firstName
                                                    ) +
                                                    " " +
                                                    _vm._s(data.item.lastName) +
                                                    "\n                "
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "item",
                                            fn: function(data) {
                                              return [
                                                _c(
                                                  "v-list-tile-content",
                                                  [
                                                    _c("v-list-tile-title", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          data.item.firstName +
                                                            " " +
                                                            data.item.lastName
                                                        )
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        635226272
                                      ),
                                      model: {
                                        value: _vm.existingCustomer,
                                        callback: function($$v) {
                                          _vm.existingCustomer = $$v
                                        },
                                        expression: "existingCustomer"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                !_vm.existingCustomer
                                  ? _c("h4", [_vm._v("Create New Customer:")])
                                  : _c("h4", [_vm._v("Existing Customer")]),
                                _vm._v(" "),
                                _c("v-divider"),
                                _vm._v(" "),
                                _vm.$v.customer.firstName.$error
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v("Please enter first name")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: {
                                    label: "First Name",
                                    v: _vm.$v.customer.firstName
                                  },
                                  model: {
                                    value: _vm.customer.firstName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.customer, "firstName", $$v)
                                    },
                                    expression: "customer.firstName"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.$v.customer.lastName.$error
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v("Please enter last name")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: "Last Name" },
                                  model: {
                                    value: _vm.customer.lastName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.customer, "lastName", $$v)
                                    },
                                    expression: "customer.lastName"
                                  }
                                }),
                                _vm._v(" "),
                                !_vm.$v.customer.email.required &&
                                _vm.$v.customer.email.$error
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v("Please enter email")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.$v.customer.email.email
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v("Please enter valid email")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: "Email" },
                                  model: {
                                    value: _vm.customer.email,
                                    callback: function($$v) {
                                      _vm.$set(_vm.customer, "email", $$v)
                                    },
                                    expression: "customer.email"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.$v.customer.phone.$error
                                  ? _c("div", { staticClass: "red--text" }, [
                                      _vm._v("Please enter phone")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  attrs: { label: "Phone" },
                                  model: {
                                    value: _vm.customer.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.customer, "phone", $$v)
                                    },
                                    expression: "customer.phone"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-card",
                                  [
                                    _c("v-card-title", [
                                      _c("h4", [_vm._v("Address:")])
                                    ]),
                                    _vm._v(" "),
                                    _c("v-divider"),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      [
                                        _vm.$v.address.address.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [
                                                _vm._v(
                                                  "Please enter street address"
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Street Address" },
                                          model: {
                                            value: _vm.address.address,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.address,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression: "address.address"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.$v.address.city.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [_vm._v("Please enter city")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Suburb / City" },
                                          model: {
                                            value: _vm.address.city,
                                            callback: function($$v) {
                                              _vm.$set(_vm.address, "city", $$v)
                                            },
                                            expression: "address.city"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.$v.address.state.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [_vm._v("Please select state")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.states,
                                            "item-text": "name",
                                            "item-value": "code",
                                            label: "State"
                                          },
                                          model: {
                                            value: _vm.address.state,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.address,
                                                "state",
                                                $$v
                                              )
                                            },
                                            expression: "address.state"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.$v.address.postcode.$error
                                          ? _c(
                                              "div",
                                              { staticClass: "red--text" },
                                              [_vm._v("Please enter postcode")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("v-text-field", {
                                          attrs: { label: "Postcode" },
                                          model: {
                                            value: _vm.address.postcode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.address,
                                                "postcode",
                                                $$v
                                              )
                                            },
                                            expression: "address.postcode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "Different Shipping Address?"
                                  },
                                  model: {
                                    value: _vm.differentShippingAddress,
                                    callback: function($$v) {
                                      _vm.differentShippingAddress = $$v
                                    },
                                    expression: "differentShippingAddress"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.differentShippingAddress
                                  ? _c(
                                      "v-card",
                                      [
                                        _c("v-card-title", [
                                          _c("h4", [_vm._v("Shiping Address:")])
                                        ]),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                        _vm._v(" "),
                                        _c(
                                          "v-card-text",
                                          [
                                            _vm.$v.shippingAddress.address
                                              .$error
                                              ? _c(
                                                  "div",
                                                  { staticClass: "red--text" },
                                                  [
                                                    _vm._v(
                                                      "Please enter street address"
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Street Address"
                                              },
                                              model: {
                                                value:
                                                  _vm.shippingAddress.address,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.shippingAddress,
                                                    "address",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "shippingAddress.address"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.$v.shippingAddress.city.$error
                                              ? _c(
                                                  "div",
                                                  { staticClass: "red--text" },
                                                  [_vm._v("Please enter city")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("v-text-field", {
                                              attrs: { label: "Suburb / City" },
                                              model: {
                                                value: _vm.shippingAddress.city,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.shippingAddress,
                                                    "city",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "shippingAddress.city"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.$v.shippingAddress.state.$error
                                              ? _c(
                                                  "div",
                                                  { staticClass: "red--text" },
                                                  [
                                                    _vm._v(
                                                      "Please select state"
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.states,
                                                "item-text": "name",
                                                "item-value": "code",
                                                label: "State"
                                              },
                                              model: {
                                                value:
                                                  _vm.shippingAddress.state,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.shippingAddress,
                                                    "state",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "shippingAddress.state"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.$v.shippingAddress.postcode
                                              .$error
                                              ? _c(
                                                  "div",
                                                  { staticClass: "red--text" },
                                                  [
                                                    _vm._v(
                                                      "Please enter postcode"
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("v-text-field", {
                                              attrs: { label: "Postcode" },
                                              model: {
                                                value:
                                                  _vm.shippingAddress.postcode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.shippingAddress,
                                                    "postcode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "shippingAddress.postcode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      1 === 1
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "form",
                                {
                                  staticStyle: { display: "none" },
                                  attrs: { enctype: "multipart/form-data" },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.sendFile($event)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "label",
                                        attrs: { for: "checkMeasure" }
                                      },
                                      [_vm._v(" Upload File ")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "checkMeasure",
                                      attrs: {
                                        type: "file",
                                        accept: ".jpg, .jpeg, .png, .pdf",
                                        multiple: ""
                                      },
                                      on: { change: _vm.selectFile }
                                    })
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.checkMeasure.click()
                                    }
                                  }
                                },
                                [_vm._v("Browse check Measure")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.sendFile()
                                    }
                                  }
                                },
                                [_vm._v("Upload")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _vm._l(_vm.checkMeasures, function(file, index) {
                            return _c(
                              "div",
                              { key: "aa" + index, staticClass: "level" },
                              [
                                _c(
                                  "v-container",
                                  {
                                    staticStyle: { background: "#ddd" },
                                    attrs: { fluid: "", "grid-list-xl": "" }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm6: "" } },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "level-item" },
                                              [
                                                _vm._v(
                                                  _vm._s(file.name) + "   "
                                                ),
                                                _vm.order.checkMeasureImg.includes(
                                                  file.name
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(wil be overwrite)"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm6: "" } },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.checkMeasures.splice(
                                                      index,
                                                      1
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("delete")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.order.checkMeasureImg, function(
                            file,
                            index
                          ) {
                            return _c(
                              "div",
                              { key: "bb" + index, staticClass: "level" },
                              [
                                _c(
                                  "v-container",
                                  { attrs: { fluid: "", "grid-list-xl": "" } },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm6: "" } },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "level-item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downloadCheckMeasure(
                                                      file
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(file))]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", sm6: "" } },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.order.checkMeasureImg.splice(
                                                      index,
                                                      1
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("delete")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-xl": "" } },
                            [
                              _c("v-textarea", {
                                attrs: { name: "remarks", label: "Remarks" },
                                model: {
                                  value: _vm.order.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.order, "remarks", $$v)
                                  },
                                  expression: "order.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.customerSavingError
                        ? _c("div", { staticClass: "red--text" }, [
                            _vm._v(_vm._s(_vm.customerSavingError))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !this.$route.params.id && !this.order._id
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", large: "" },
                              on: {
                                click: function($event) {
                                  return _vm.addOrder()
                                }
                              }
                            },
                            [_vm._v("Add")]
                          )
                        : _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", large: "" },
                              on: {
                                click: function($event) {
                                  return _vm.updateOrder()
                                }
                              }
                            },
                            [_vm._v("Update")]
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _c("label", [_vm._v("Select a product type to add:")]),
                  _c("br"),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: [
                        { text: "Roller Blind" },
                        { text: "Double Roller Blind" },
                        { text: "Roman Blind" },
                        { text: "Soft Roman Blind" },
                        { text: "Venetian Blind" },
                        { text: "Honeycomb Blind" },
                        { text: "Shutter" },
                        { text: "3D Shutters" },
                        { text: "Linked Roller Blind" },
                        { text: "Linked Double Roller Blind" },
                        { text: "Shutter" },
                        { text: "Panel Glide Blind" },
                        { text: "Vertical Blind" },
                        { text: "Curtain" },
                        { text: "Double Curtain" },
                        { text: "Lined Curtain" },
                        { text: "Curved Curtain" },
                        { text: "Bay Window Curtain" },
                        { text: "Custom Curtain" },
                        { text: "Motor Accessories" },
                        { text: "Pelmets" },
                        { text: "Scaffold" },
                        { text: "Misc" }
                      ],
                      label: "Add Item to Quote"
                    },
                    on: { change: _vm.checkEdit },
                    model: {
                      value: _vm.itemType,
                      callback: function($$v) {
                        _vm.itemType = $$v
                      },
                      expression: "itemType"
                    }
                  }),
                  _vm._v(" "),
                  _vm.itemType
                    ? _c(
                        "v-card",
                        [
                          !_vm.edit
                            ? _c("v-card-title", [
                                _c("h4", [
                                  _vm._v("Add " + _vm._s(_vm.itemType))
                                ])
                              ])
                            : _c("v-card-title", [
                                _c("h4", [
                                  _vm._v("Edit " + _vm._s(_vm.itemType))
                                ])
                              ]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _vm.itemType == "Roller Blind"
                                ? _c("rollerBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Linked Roller Blind"
                                ? _c("linkedRollerBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Shutter"
                                ? _c("shutter", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "3D Shutters"
                                ? _c("shutter3D", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Curtain"
                                ? _c("curtain", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Double Curtain"
                                ? _c("doubleCurtain", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Lined Curtain"
                                ? _c("linedCurtain", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Curved Curtain"
                                ? _c("curvedCurtain", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Bay Window Curtain"
                                ? _c("bayWindowCurtain", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Double Roller Blind"
                                ? _c("doubleRollerBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Linked Double Roller Blind"
                                ? _c("linkedDoubleRollerBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Misc"
                                ? _c("misc", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Panel Glide Blind"
                                ? _c("panelGlideBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Roman Blind"
                                ? _c("romanBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Soft Roman Blind"
                                ? _c("softRomanBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Venetian Blind"
                                ? _c("venetianBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Vertical Blind"
                                ? _c("verticalBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Honeycomb Blind"
                                ? _c("honeycombBlind", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Motor Accessories"
                                ? _c("motorAccessories", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Pelmets"
                                ? _c("pelmets", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Scaffold"
                                ? _c("scaffold", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemType == "Custom Curtain"
                                ? _c("CustomCurtain", {
                                    attrs: {
                                      edittingItem: _vm.edittingItem,
                                      editChange: _vm.editChange
                                    },
                                    on: {
                                      "create-item": function($event) {
                                        return _vm.addItem($event)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _vm.edit
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary " },
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelItem()
                                        }
                                      }
                                    },
                                    [_vm._v("Cancel")]
                                  )
                                : _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary " },
                                      on: {
                                        click: function($event) {
                                          _vm.itemType = null
                                        }
                                      }
                                    },
                                    [_vm._v("Done")]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", width: "300" },
                  model: {
                    value: _vm.sending,
                    callback: function($$v) {
                      _vm.sending = $$v
                    },
                    expression: "sending"
                  }
                },
                [
                  _c(
                    "v-card",
                    { attrs: { color: "primary", dark: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _vm._v(
                            "\n                Processing...\n                "
                          ),
                          _c("v-progress-linear", {
                            staticClass: "mb-0",
                            attrs: { indeterminate: "", color: "white" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400px" },
          model: {
            value: _vm.customerDialog,
            callback: function($$v) {
              _vm.customerDialog = $$v
            },
            expression: "customerDialog"
          }
        },
        [
          _vm.selectedItem
            ? _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v("Please confirm")]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("p", [
                      _vm._v("Are you sure you want to delete "),
                      _c("b", [_vm._v(_vm._s(_vm.selectedItem.name))]),
                      _vm._v("?")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.customerDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.deleteItem(_vm.selectedItem.id)
                            }
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.fetchFromCartModal,
            callback: function($$v) {
              _vm.fetchFromCartModal = $$v
            },
            expression: "fetchFromCartModal"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Search Cart Orders")]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "p",
                    [
                      _c("v-text-field", {
                        attrs: { label: "Width (Any Item)" },
                        model: {
                          value: _vm.cartOrderWidth,
                          callback: function($$v) {
                            _vm.cartOrderWidth = $$v
                          },
                          expression: "cartOrderWidth"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c("v-text-field", {
                        attrs: { label: "Drop (Same Item)" },
                        model: {
                          value: _vm.cartOrderDrop,
                          callback: function($$v) {
                            _vm.cartOrderDrop = $$v
                          },
                          expression: "cartOrderDrop"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.fetchCartOrders()
                        }
                      }
                    },
                    [_vm._v("Fetch Orders")]
                  ),
                  _vm._v(" "),
                  _vm.cartOrders.length
                    ? _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.cartOrders,
                              "item-text": "code",
                              "item-value": "id",
                              label: "Select Cart Order"
                            },
                            on: {
                              change: function($event) {
                                return _vm.getItemsFromOrderId(
                                  _vm.selectedCartOrder
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedCartOrder,
                              callback: function($$v) {
                                _vm.selectedCartOrder = $$v
                              },
                              expression: "selectedCartOrder"
                            }
                          }),
                          _vm._v(" "),
                          _vm.cartItems
                            ? _c(
                                "div",
                                [
                                  _c("v-label", [_vm._v("Items")]),
                                  _vm._v(" "),
                                  _vm._l(_vm.cartItems, function(item) {
                                    return _c(
                                      "div",
                                      { key: item._id },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            class:
                                              parseInt(item.width) ===
                                                parseInt(_vm.cartOrderWidth) &&
                                              parseInt(item.drop) ===
                                                parseInt(_vm.cartOrderDrop)
                                                ? "color-green"
                                                : "",
                                            attrs: {
                                              xs12: "",
                                              "mb-2": "",
                                              "pa-1": ""
                                            }
                                          },
                                          [
                                            _c("b", [_vm._v("Name:")]),
                                            _vm._v(
                                              " " + _vm._s(item.name) + ", "
                                            ),
                                            _c("b", [_vm._v("Width:")]),
                                            _vm._v(
                                              " " + _vm._s(item.width) + ", "
                                            ),
                                            _c("b", [_vm._v("Drop:")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(item.drop) +
                                                "\n               "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.createQuoteFromCart()
                                }
                              }
                            },
                            [_vm._v("Create Quote")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.fetchFromCartModal = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-137b3dd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137b3dd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/quotes/Quote.vue
// module id = null
// module chunks = 